import { withInstall } from '@element-plus/utils'
import Tooltip from './src/tooltip.vue'

export const ElTooltip = withInstall(Tooltip)
export * from './src/tooltip'
export * from './src/trigger'
export * from './src/content'
export default ElTooltip
